import { IProduktionsenhed } from "@/interfaces/firma";
import { get } from "../util";
import type { CvrSearchHitDto } from "./types";

const CVR_SEARCH_PATH = "grunddata/cvr/search";
const PRODUKTIONSENHEDER_PATH = "grunddata/cvr/{cvrNr}/penhed";

export interface CvrSearchParams {
  q: string;
  limit?: number;
}

export interface ProduktionsenhederParams {
  cvrNr: number;
}

/**
 * Calls the CVR search REST API and returns raw hits.
 * Backend is expected to expose GET grunddata/cvr/search?q=...&limit=...
 */
export async function getCvrSearch(
  params: CvrSearchParams,
): Promise<CvrSearchHitDto[]> {
  const { q, limit = 10 } = params;
  const query = [
    q ? `q=${encodeURIComponent(q.trim())}` : "",
    limit ? `limit=${limit}` : "",
  ]
    .filter(Boolean)
    .join("&");
  const path = query ? `${CVR_SEARCH_PATH}?${query}` : CVR_SEARCH_PATH;
  const data = await get<CvrSearchHitDto[] | { hits?: CvrSearchHitDto[] }>({
    query: path,
  });
  if (Array.isArray(data)) return data;
  if (data?.hits && Array.isArray(data.hits)) return data.hits;
  return [];
}

export async function getProduktionsenhederForCvrNummer(
  cvrNr: number,
): Promise<IProduktionsenhed[]> {
  const data = await get<IProduktionsenhed[]>({
    query: `${PRODUKTIONSENHEDER_PATH.replace("{cvrNr}", cvrNr.toString())}`,
  });
  console.log(data);
  return data ?? [];
}
